import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const DocumentService = {
    getAllByProject: async (pro_id) => {
        const res = await axios.get(`${ENDPOINT.Document}/project/${pro_id}`);
        return res.data;
    },
    createDocument: async (data) => {
        const res = await axios.post(ENDPOINT.Document, data, {
            headers: { "Content-Type": "application/json" },
        });
        return res.data;
    },
    deleteDocument: async (id) => {
        const res = await axios.delete(`${ENDPOINT.Document}/${id}`);
        return res.data;
    },
};